import MasterCrudPage from "@/components/MasterCrudPage";

export default function Departments() {
  return (
    <MasterCrudPage
      endpoint="/departments"
      title="Departments"
      breadcrumbs={["Masters", "Departments"]}
      testIdPrefix="dept"
      initialForm={{ is_active: true }}
      columns={[
        { key: "code", label: "Code", width: 120 },
        { key: "name", label: "Name" },
        { key: "is_active", label: "Status", render: r => r.is_active ?
          <span className="badge-base bg-emerald-50 text-emerald-700 border-emerald-200">Active</span> :
          <span className="badge-base bg-slate-100 text-slate-500 border-slate-200">Inactive</span> },
      ]}
      formFields={[
        { key: "code", label: "Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
